/**
 * ── App brand font — SINGLE SOURCE OF TRUTH (per app) ─────────────────────────
 *
 * This is the ONE place where THIS app declares "my default typeface is X". The
 * brand font is bundled and self-contained (see `src/styles/brand-font.css` +
 * the `--font-brand*` tokens in `src/styles/global.css`); it is ALWAYS present
 * and never depends on the font catalog/registry/CDN. It is also the target of
 * the "Reset to default" control.
 *
 * The catalog/custom fonts are a purely ADDITIVE layer on top: a user MAY switch
 * to one, but that is never required for the app to have its typeface.
 *
 * Stockpilot identity: Space Grotesk — a geometric grotesque with even, tabular
 * proportions and precise figures, reading as technical and data-dense; a good
 * fit for a WMS / inventory tool. (The mono role keeps IBM Plex Mono for SKU /
 * quantity columns.)
 *
 * TO ADAPT PER APP (propagation): change `family` to this app's brand family and
 * keep it in sync with the bundled @font-face + `--font-brand*` CSS tokens.
 */
export const BRAND_FONT = {
  /**
   * CSS family name of the bundled brand typeface. MUST match the `@font-face`
   * `font-family` in `styles/brand-font.css` and the `--font-brand*` tokens.
   */
  // oxlint-disable-next-line lingui/no-unlocalized-strings -- CSS font-family name, never localized
  family: "Space Grotesk",
  /** Proper noun of the typeface (brand identity) — not localizable copy. */
  // oxlint-disable-next-line lingui/no-unlocalized-strings -- typeface proper noun
  label: "Space Grotesk",
} as const;

export type BrandFont = typeof BRAND_FONT;
